export default {
  refund: 'Refund',
  refund_instructions: 'Refund Instructions',
  customer_order_no: 'Customer Order No',
  transaction_type: 'Transaction Type',
  merchant_order_id: 'Merchant Order ID',
  create_time: 'Create Time',
  creator: 'Creator',
  transaction_amount: 'Amount',
  transaction_status: 'Status',
  fee: 'Fee',
  institute_id: 'Channel ID',
  merchant_name: 'Merchant Name',
  product_name: 'Product Name',
  refundable_amount: 'Refundable Amount',
  payment_details: 'Payment Details',
  payout_details: 'Pay Out Details',
  payment: 'Payin',
  payout: 'Payout',
  disburse: 'Disburse',
  payment_serial_number: 'Payin Serial Number',
  stream_creation_time: 'Stream Creation Time',
  organization_return_order_time: 'Organization Return Order Time',
  retry_notice: 'Retry Notice',
  mobile: 'Mobile',
  customer_phone_number: 'Customer Phone Number',
  account_no: 'Account No',
  account_number: 'Account Number',
  bill_account_no: 'Reference Number',
  qr_link: 'QR Link',
  qr_download: 'Download Link',
  qr_code_id: 'QR Code ID',
  work_order_number: 'Ticket ID',
  institution_type: 'Channel Type',
  business_type: 'Transaction Type',
  transaction_id: 'Transaction ID',
  reference_no: 'Invoice No.',
  void_transaction_id: 'Void Transaction ID',
  void_complete_time: 'Void Complete Time',
  issue: 'Issue',
  conclusion: 'Conclusion',
  replies: 'Replies',
  reply: 'Reply',
  reopen: 'Reopen',
  cs_intervention_time: 'CS Intervention Time',
  cs_completion_time: 'CS Completion Time',
  image: 'Image',
  add_work_order: 'New Ticket',
  payment_code: 'Reference/Account No.',
  app_name: 'App Name',
  payer_mobile: 'Payer Mobile No.',
  remitting_bank: 'Remitting Bank',
  remittance_account: 'Remitting Account',
  payment_method: 'Payment Method',
  description: 'Description',
  transaction_history: 'Transaction History',
  payment_receipt: 'Payment Receipt',
  attachments: 'Attachments',
  reference: 'Reference',
  submit_quantity: 'Submit',
  success_quantity: 'Success',
  pending_quantity: 'Pending',
  fail_quantity: 'Failed',
  validation: 'Validation',
  single_payment_link: 'Single Collection',
  batch_payment_link: 'Multiple Collection',
  create_single_payment_link: 'Single Payment Link',
  create_batch_payment_link: 'Batch Payment Link',
  payment_channel: 'Payment Channel',
  email_content: 'Message',
  beneficiary_mobile: 'Beneficiary Mobile',
  email_address: 'Beneficiary Email',
  customer_name: 'Customer Name',
  download_template: 'Download template',
  upload_file_template: 'Upload filled template',
  edit_collection: 'Edit Collection',
  payin_search: 'Payin Search',
  payout_search: 'Payout Search',
  card_verification_search: 'Account Validation Search',
  other_details: 'Other Details',
  ticket_details: 'Ticket Details',
  re_open_ticket: 'Re-open Ticket',
  ph_invoice_no: 'PH Invoice No.',
  qrph_invoice_no: 'QRPH Invoice No.',
  invoice_no: 'Invoice No.',
  wayBill_num: 'WayBill Num',
  wayBill_status: 'WayBill Status',
  refund_search: 'Refund Search',
  original_transaction_id: 'Original Transaction ID',
  refund_type: 'Refund Type',
  full_refund: 'Full refund',
  partial_refund: 'Partial refund',
  original_transaction_amount: 'Original Transaction Amount',
  refund_transaction_id: 'Refund Transaction ID',
  refund_amount_already: 'Refund amount already',
  present_refund_amount: 'Present refund amount',
  refund_order_amount: 'Refund Order Amount',
  refund_fee: 'Refund Fee',
  refund_failed_fee: 'Refund Fee(Failed)',
  amount_to_receive: 'Amount to Receive',
  refund_fee_charge_mode: 'Refund Fee Charge Mode',
  refund_reason: 'Refund Reason',
  cumulative_amount_refunded: 'Cumulative Order Amount Refunded',
  remaining_refundable_order_amount: 'Remaining Refundable Order Amount',
  original_transaction_fee_charge_mode: 'Original Transaction Fee Charge Mode',
  total_refunded_amount: 'Total refunded amount',
  refund_status: 'Refund Status',
  refund_transaction_details: 'Refund transaction details',
  refund_amount: 'Refund Amount',
  refunded_transaction_fee: 'Fee Refunded',
  refund_commission_amount: 'Refund commission amount',
  refund_commission_amount_summary: 'Refund commission amount summary',
  refund_commission_amount_number: 'Refund commission amount number',
  refund_transactions_number: 'Refund transactions number',
  refund_channel_refund_fee_amount: 'Refund channel refund fee amount',
  refunds_summary: 'Refunds summary',
  full_refund_summary: 'Total Refund Transaction Amount',
  return_fee_summary: 'Total Fee Refunded',
  total_refund_fee: 'Total Refund Fee',
  actual_refund_amount_received: 'Refund initiator\'s credited amount',
  refund_transaction_amount: 'Refund Transaction Amount',
  transaction_fee_change_mode: 'Fee bearer',
  refund_order_status: 'Refund Order Status',
  request_refund_amount: 'Request refund amount',
  refund_transaction_status: 'Refund transaction status',
  refund_transactions_number_summary: 'Refund commission amount summary',
  remaining_refundable_amount: 'Remaining refundable amount',
  process_refund_transactions: 'Process refund transactions',
  process_refund_details: 'Process Refund Details',
  handle_time: 'Handle Time',
  mch_refund_order_id: 'Merchant Refund Order ID',
  bill_no: 'Bill No',
  bill: 'Bill',
  loan_type: 'Loan Type',
  customer_no: 'Customer No',
  beneficiary_account: 'Beneficiary Account',
  loan_channel: 'Loan Channel',
  asset_belonged: 'Asset Belonged',
  funding_parties: 'Funding Parties',
  credit_type: 'Credit Type',
  loan_amount: 'Loan Amount',
  credit_service: 'Credit Service',
  current_fx: 'Current FX',
  repay_method: 'Repay Method',
  repayment_amount: 'Repayment Amount',
  down_payment_amount: 'Down Payment Amount',
  installment_amount: 'Installment Amount',
  payment_order_number: 'Payment Order Number',
  loan_status: 'Loan Status',
  collection_channel_type: 'Collection Channel Type',
  account: 'Account',
  payee_type: 'Payee Type',
  payee_id_number: 'Payee ID Number',
  payee_relationship: 'Payee Relationship',
  payee_phone_number: 'Payee Phone Number',
  bill_amount: 'Bill Amount',
  principal_repayment_amount: 'Principal Amount',
  penalty_repayment_amount: 'Penalty',
  interest: 'Interest',
  installment_term: 'Installment Term',
  due_date: 'Due Date',
  loan_transaction_no: 'Loan Transaction No',
  repay_transaction_no: 'Repay Transaction No',
  transaction_id_wallet: 'Transaction Id',
  amount: 'Amount',
  installment_amount_wallet: 'Installment Amount',
  status: 'Status',
  jt_issuer_name: 'Issuer Name',
  aggregate_cod_Amount: 'Aggregate Cod Amount',
  aggregate_cod_fee_amount: 'Aggregate Cod Fee Amount',
  aggregate_frt_amount: 'Aggregate Frt Amount',
  aggregate_frt_fee_amount: 'Aggregate Frt Fee Amount',
  transaction_fee_charge_mode: 'Transaction Fee Charge Mode',
  charge_to_merchants: 'Charge to Merchants',
  charge_to_customer: 'Charge to Customer',
  payment_type: 'Payment Type',
  paid_account_no_suffix: 'Paid Account No Suffix',
  billing_address: 'Billing Address',
  qr_stand_id: 'QR Stand ID',
  amount_refunded_successfully: 'Amount Refunded Successfully',
  pay_card_no: 'Card No',
  pay_card_scheme: 'Card Scheme',
  pay_card_issuer: 'Issuer'
}
